'use client';

import React, { useEffect, useRef, useState } from 'react';
import styles from './Navbar.module.css';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname, useRouter } from 'next/navigation';
import { Nav, Navbar as BootstrapNavbar } from '@/components/reactbootstrap';
import SSPIconTransparent from '@/public/SSPIconTransparent.png';

const Navbar = () => {
	const router = useRouter();
	const pathname = usePathname();
	const [scrolled, setScrolled] = useState(false);
	const navbarRef = useRef();

	useEffect(() => {
		const handleScroll = () => {
			const offset = window.scrollY;
			if (offset > 60) {
				setScrolled(true);
			} else {
				setScrolled(false);
			}
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		return () => {
			window.removeEventListener('scroll', handleScroll, { passive: true });
		};
	}, []);

	return (
		<BootstrapNavbar 
			expand="lg" 
			className={`${styles.customNavbar} ${scrolled ? styles.sticky : ''}`}
			ref={navbarRef}
		>
			<div className={styles.navContainer}>
				<BootstrapNavbar.Brand className={styles.navbarBrand} onClick={() => router.push('/')}>
					<Image
						src={SSPIconTransparent}
						alt="Supply Sense Pro"
						width={50}
						height={50}
						className={styles.logoImage}
					/>
					<span className={styles.brandName}>SupplySense Pro</span>
				</BootstrapNavbar.Brand>
				<BootstrapNavbar.Toggle aria-controls="basic-navbar-nav" />
				<BootstrapNavbar.Collapse id="basic-navbar-nav">
					<Nav className={styles.navLinksContainer}>
						<Link href="/" className={`${styles.navLink} ${pathname === '/' ? styles.active : ''}`}>
							<div className={styles.iconContainer}>
								<i className="fas fa-house" />
							</div>
							<span>Home</span>
						</Link>
						<Link href="/pricing"
							className={`${styles.navLink} ${pathname === '/pricing' ? styles.active : ''}`}>
							<div className={styles.iconContainer}>
								<i className="fas fa-tag" />
							</div>
							<span>Pricing</span>
						</Link>
						<Link href="/contact"
							className={`${styles.navLink} ${pathname === '/contact' ? styles.active : ''}`}>
							<div className={styles.iconContainer}>
								<i className="fa-regular fa-address-book" />
							</div>
							<span>Contact</span>
						</Link>
						{(pathname === '/auth/login' || pathname === '/auth/signup') ? '' : (
							<Link href="/dashboard"
								className={`${styles.dashboardBtn} ${pathname === '/dashboard' ? styles.active : ''}`}>
								<div className={styles.iconContainer}>
									<i className="fas fa-tachometer-alt" />
								</div>
								<span>Dashboard</span>
							</Link>
						)}
					</Nav>
				</BootstrapNavbar.Collapse>
			</div>
		</BootstrapNavbar>
	);
};

export default Navbar;